import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { MediaContentDto, TemplateContentType } from "../dto";
import { ApiService, nonFalsyPayload } from "../core";

@Injectable({
  providedIn: "root"
})
export class MediaContentService {
  private serviceUrl = "mediaContent";

  constructor(private api: ApiService) {}

  getMediaContent(id: number): Observable<MediaContentDto> {
    return this.api.get(`${this.serviceUrl}/${id}`);
  }

  getByTemplateContentType(templateContentType: TemplateContentType, brandId?: number): Observable<MediaContentDto[]> {
    const params = nonFalsyPayload({ brandId });
    return this.api.get(`${this.serviceUrl}/templateContentType/${templateContentType}`, params);
  }
}
